export enum TaxSubmissionStatus {
    REJECTED = "REJECTED",
    SENT = "SENT",
    SENT_WITH_WARNINGS = "SENT_WITH_WARNINGS",
    READY_TO_SEND = "READY_TO_SEND",
    NOT_SENT_WITH_ERRORS = "NOT_SENT_WITH_ERRORS",
    OUTCOME_DOWNLOAD_ERROR = "OUTCOME_DOWNLOAD_ERROR",
    PENDING = "PENDING",
    GENERIC_ERROR = "GENERIC_ERROR",
    EXPIRED = "EXPIRED",
}

// Statuses for which we want to show the warning icon in the UI
export const WARNING_SENT_STATUSES = [
    TaxSubmissionStatus.SENT_WITH_WARNINGS,
    TaxSubmissionStatus.OUTCOME_DOWNLOAD_ERROR,
];
